module.exports = __webpack_public_path__ + "img/i_mooc_phon.aa614d44.png";